import * as React from 'react'
import { RestLaneResolver } from '../layers/lanes'

const NOOP_RESOLVER: RestLaneResolver = {
  restLaneFor: () => 0,
  restIsTop: () => true,
}

const LanesContext = React.createContext<RestLaneResolver>(NOOP_RESOLVER)

export const LanesProvider = LanesContext.Provider

export const useRestLanes = (): RestLaneResolver =>
  React.useContext(LanesContext)
